import clients from 'modules/client/permissions';
import { permissions as providers } from './Providers/permissions';

export const menu = {
  to: '/contacts',
  label: 'Contacts',
  icon: 'user-group' as const,
  children: [
    { to: '/contacts/clients', label: 'Clients', visible: clients.view },
    { to: '/contacts/providers', label: 'Providers', visible: providers.view },
  ],
};
